<template>
  <button
    :class="['close-button', sizeStyle, backgroundVisibilityStyle]"
    :title="title"
    :aria-label="title"
    @click="click"
  >
    <CloseIcon color="$coal" class="close-icon" alt="close" />
  </button>
</template>

<script>
/**
 * @deprecated - use BaseButtonIcon component instead
 */
import { CloseIcon } from '@attensi/materia'
export default {
  components: {
    CloseIcon,
  },
  props: {
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    title: {
      type: String,
      required: false,
      default: 'Close',
    },
    backgroundVisibility: {
      type: String,
      required: false,
      default: 'hover',
    },
  },
  emits: ['click'],
  computed: {
    sizeStyle() {
      return `close-button--size-${this.size}`
    },
    backgroundVisibilityStyle() {
      return `close-button--background-visibility-${this.backgroundVisibility}`
    },
  },
  methods: {
    click() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.close-button {
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: $spacing-l;
  height: $spacing-l;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;

  &--background-visibility-hover {
    background: transparent;
    &:focus,
    &:hover {
      background: $color-pebble;
    }
    &:active {
      background: $color-marble;
    }
  }

  &--background-visibility-visible {
    background: $color-pebble;
    &:focus,
    &:hover {
      background: $color-marble;
    }
    &:active {
      background: $color-ash;
    }
  }

  &--background-visibility-hidden {
    background: transparent;
    &:focus,
    &:hover {
      background: transparent;
    }
    &:active {
      background: $color-marble;
    }
  }

  &--size-tiny {
    width: $spacing-s;
    height: $spacing-s;

    .close-icon {
      width: $spacing-4xs;
      height: $spacing-4xs;
    }
  }

  &--size-small {
    width: $spacing-m;
    height: $spacing-m;

    .close-icon {
      width: $spacing-3xs;
      height: $spacing-3xs;
    }
  }

  &--size-medium {
    width: $spacing-l;
    height: $spacing-l;

    .close-icon {
      width: $spacing-2xs;
      height: $spacing-2xs;
    }
  }

  &--size-large {
    width: $spacing-xl;
    height: $spacing-xl;

    .close-icon {
      width: $spacing-xs;
      height: $spacing-xs;
    }
  }
}
</style>
